// ToolLine.tsx

import React from "react"
import { View } from "react-native"
import { type StyleProp, type ViewStyle } from "react-native"
import { BFColors } from "@/constants/Colors"

interface ToolLineProps {
  orientation?: "vertical" | "horizontal"
  width?: number
  color?: string // Line color
  style?: StyleProp<ViewStyle> // Additional custom styles
  className?: string // NativeWind
}

const ToolLine: React.FC<ToolLineProps> = ({
  orientation = "horizontal",
  width = 1, // Default thickness for vertical or width for horizontal
  color = BFColors.lightGrey,
  style,
  className = "", // NativeWind class names
}) => {
  const isHorizontal = orientation === "horizontal"

  return (
    <View
      style={[
        {
          backgroundColor: color,
          width: isHorizontal ? "100%" : width,
          height: isHorizontal ? width : "100%",
        },
        style, // Apply inline styles if provided
      ]}
      className={className} // Apply NativeWind class names if provided
    />
  )
}

export default ToolLine
